import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mpro-freemium-introduction',
  templateUrl: './freemium-introduction.component.html',
  styleUrls: ['./freemium-introduction.component.scss'],
})
export class FreemiumIntroductionComponent implements OnInit {
  @Input() isModalOpen: boolean;
  @Output() onModalClose: EventEmitter<void> = new EventEmitter();
  public faChevronRight = faChevronRight;
  public faChevronLeft = faChevronLeft;
  public steps = [1, 2, 3, 4, 5, 6, 7];
  public currentStep: number = 1;
  public callbackRequested: boolean = false;
  public displaySteps = true;
  public isFreemium: boolean;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.authService.permissions$.subscribe((plan) => {
      this.isFreemium = plan.isFreemium;
    });
    this.authService.openFreemiumRequestModal.subscribe((event) => {
      if (event.isOpen) {
        this.currentStep = 8;
        this.displaySteps = false;
      }
    });
  }

  changeStep(nextStep: boolean) {
    if (nextStep) {
      this.currentStep += 1;
      return;
    }
    this.currentStep -= 1;
  }

  public requestCallback() {
    this.authService
      .requestCallBack()
      .pipe(take(1))
      .subscribe(() => {
        this.callbackRequested = true;
      });
  }

  setPage(step: number) {
    this.currentStep = step;
  }

  public closeModal() {
    this.onModalClose.emit();
    this.authService.setFreemiumIntroductionModalOpened(false);
    this.authService.setFreemiumIntroductionAsSeen();
    this.callbackRequested = false;
    this.isModalOpen = false;
  }
}
